import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propArrayShape, propFunc, propShape, } from '../../../../../../../helpers/custom-prop-types';
import UploadHistoryShareColRow from './UploadHistoryShareColRow';
const UploadHistoryShareColRows = (props) => {
    const { item, onSubmitBlock, shares, updateMap } = props;
    const { id: itemId } = item;
    const initialValues = useMemo(() => {
        const result = {};
        shares.forEach((v) => {
            const { blockDownload, blockShare } = v;
            const shareChecked = updateMap[`${itemId}_${v.id}_share`];
            const blockChecked = updateMap[`${itemId}_${v.id}_block`];
            result[v.id] = {
                blockDownload: !!(blockChecked === undefined
                    ? blockDownload
                    : blockChecked),
                blockShare: !!(shareChecked === undefined ? blockShare : shareChecked),
            };
        });
        return result;
    }, [shares, itemId, updateMap]);
    if (shares.length === 0) {
        return (_jsxs("div", Object.assign({ className: 'rowspan_row share_col_inner' }, { children: [_jsx("div", Object.assign({ className: 'share_col_share_col' }, { children: "\u306A\u3057" })), _jsx("div", { className: 'share_col_block_share_col' }), _jsx("div", { className: 'share_col_block_download_col' }), _jsx("div", { className: 'share_col_edit_col' })] })));
    }
    return shares.map((v) => (_jsx(UploadHistoryShareColRow, { form: `UploadHistoryShareColRow_${item.id}_${v.id}`, initialValues: initialValues[v.id], onSubmit: onSubmitBlock, shareUser: v, slideId: item.id, userId: v.id }, v.id)));
};
UploadHistoryShareColRows.propTypes = {
    item: propShape().isRequired,
    onSubmitBlock: propFunc().isRequired,
    shares: propArrayShape().isRequired,
    updateMap: propShape().isRequired,
};
export default UploadHistoryShareColRows;
